import { render, staticRenderFns } from "./AddAdminForm.vue?vue&type=template&id=184acc62"
import script from "./add-admin-form.ts?vue&type=script&lang=ts&external"
export * from "./add-admin-form.ts?vue&type=script&lang=ts&external"
import style0 from "./add-admin-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports